import type { UserPreferences } from "../types/user-preferences";

export const DEFAULT_USER_PREFERENCES: UserPreferences = {
  timezone: {
    label: "Greenwich Mean Time (GMT)",
    value: "America/New_York",
  },
  language: {
    label: "English",
    value: "en",
  },
  locale: {
    label: "English (United States)",
    value: "en-US",
    currency_before: true,
    currency_code: "USD",
    date_format: "MM/DD/YYYY",
    time_format: "12h",
    local_date_format: "MM/DD/YYYY",
    local_time_format: "12h",
    first_day_of_week: 0,
  },
  theme: {
    label: "SmartSuite Primary",
    value: "smartsuite_primary",
    button_color: "#ff6f2c",
    heading_color: "#00a6ed",
  },
  profile_image: null,
  full_name: {
    first_name: "John",
    last_name: "Smith",
  },
  email: "john.smith@smartsuite.com",
};

export const EMPTY_USER_PREFERENCES: UserPreferences = {
  timezone: {
    label: "",
    value: "",
  },
  language: {
    label: "",
    value: "",
  },
  locale: {
    label: "",
    value: "",
    currency_before: true,
    currency_code: "",
    date_format: "",
    time_format: "",
    local_date_format: "",
    local_time_format: "",
    first_day_of_week: 0,
  },
  theme: {
    label: "",
    value: "",
    button_color: "",
    heading_color: "",
  },
  profile_image: null,
  full_name: {
    first_name: "",
    last_name: "",
  },
  email: "",
};
